// extracted by mini-css-extract-plugin
export var cls1 = "DobleSemicorcheaSvg-module--cls-1--Yj+1p";